"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
const ReplacesEnum_1 = require("../ReplacesEnum");
exports.Common = Object.freeze({
    EXTENSION_NAME: 'Omnito Meeting Booker: Planification fluide',
    EXTENSION_SHORT_NAME: 'Omnito Inbox',
    EXTENSION_DESCRIPTION: 'Simplifiez la planification ! En un clic, connectez votre calendrier, définissez votre disponibilité et envoyez des invitations pour être sûr de ne jamais avoir de double réservation.',
    EXTENSION_BUTTON_TOOLTIP: 'Insérer Omnito Meeting Booker',
    AUTHORIZATION_SERVER_ONE: 'Omnito',
    AUTHORIZATION_SERVER_SALESFORCE: 'Omnito pour Salesforce (CEP)',
    AUTHORIZATION_SERVER_SALESFORCE_PRODUCTION: 'Production',
    AUTHORIZATION_SERVER_SALESFORCE_SANDBOX: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_SUMO1_LOGIN_TITLE: 'Omnito',
    ACTIVE_TAB_SIDEBAR_SALESFORCE_LOGIN_TITLE: 'Omnito pour Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_BUTTON: 'Se connecter',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_GOOGLE_BUTTON: 'Se connecter avec Google',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_MICROSOFT_BUTTON: 'Se connecter avec Microsoft',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_BUTTON: 'Se connecter avec Salesforce',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_PRODUCTION_BUTTON: 'Production',
    ACTIVE_TAB_SIDEBAR_LOGIN_WITH_SALESFORCE_SANDBOX_BUTTON: 'Sandbox',
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_TEXT: "Vous n'avez pas de compte ?",
    ACTIVE_TAB_SIDEBAR_LOGIN_TRIAL_LINK: "S'inscrire",
    ACTIVE_TAB_SIDEBAR_CREATE_MEETING_BUTTON: 'Créer une réunion',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN: 'Bienvenue, vous êtes connecté.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LABEL_LOGGED_IN_CREATE_MEETING_BUTTON: 'Cliquez sur Créer une réunion pour ajouter des créneaux horaires à votre e-mail.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_1: "1. Ouvrez <a target='_blank' class='text-blue-100 no-underline' href='https://mail.google.com'>Gmail.com</a> ou <a target='_blank' class='text-blue-100 no-underline' href='https://outlook.live.com'>Outlook.live.com</a> et créez un nouvel e-mail",
    GMAIL_URL: 'gmail.com',
    OUTLOOK_URL: 'outlook.live.com',
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_2: "2. Cliquez sur l'icône Meeting Booker",
    ACTIVE_TAB_SIDEBAR_WELCOME_LIST_ITEM_3: '3. Make booking faster. Connect your contacts to speed up booking.',
    ACTIVE_TAB_SIDEBAR_ALLOW_CONTACTS_ACCESS_BUTTON: 'Allow access',
    SCHEDULER_CONNECT_CONTACTS_BANNER_TITLE: 'Make booking faster',
    SCHEDULER_CONNECT_CONTACTS_BANNER_DESCRIPTION: 'Connect your Google Contacts to quickly find people and autofill meeting details.',
    ACTIVE_TAB_SIDEBAR_WELCOME_LOGOUT_BUTTON: 'Se déconnecter',
    ACTIVE_TAB_SETTINGS_LOGOUT_BUTTON: 'Se déconnecter',
    SCHEDULER_DEFAULT_WORKSPACE_LABEL: 'Espace de travail par défaut',
    SCHEDULER_WORKSPACE_LABEL: 'Espace de travail',
    SCHEDULER_WORKSPACE_TOOLTIP: 'La liste des services et des hôtes sera mise à jour selon votre espace de travail sélectionné',
    SCHEDULER_SETTINGS_DEFAULT_PROCESS_LABEL: 'Processus par défaut',
    SCHEDULER_SETTINGS_DEFAULT_HOST_LABEL: 'Hôte par défaut',
    SCHEDULER_SETTINGS_HOST_ME_LABEL: 'Moi',
    SCHEDULER_SETTINGS_HOST_NONE_LABEL: 'Aucun',
    SCHEDULER_SETTINGS_BUTTON: 'Paramètres',
    SCHEDULER_SETTINGS_TOOLTIP: 'Paramètres',
    SCHEDULER_MEETING_NAME_LABEL: 'Nom de la réunion',
    SCHEDULER_APPOINTMENT_TITLE_LABEL: 'Titre / Type de rendez-vous',
    SCHEDULER_APPOINTMENT_TYPES_LABEL: 'Types de rendez-vous',
    SCHEDULER_APPOINTMENT_TYPES_PLACEHOLDER: 'Sélectionner les types de rendez-vous',
    SCHEDULER_APPOINTMENT_TYPES_SEARCH_PLACEHOLDER: 'Rechercher',
    SCHEDULER_APPOINTMENT_TYPES_MAX_WARNING: `Maximum ${ReplacesEnum_1.ReplacesDetailEnum.MAX} peuvent être sélectionnés.`,
    SCHEDULER_APPOINTMENT_TITLE_ONLY_LABEL: 'Titre du rendez-vous',
    SCHEDULER_APPOINTMENT_TITLE_ONLY_PLACEHOLDER: 'Saisir le titre du rendez-vous',
    SCHEDULER_TITLE_PLACEHOLDER: 'Saisir un nom',
    SCHEDULER_MEETING_TYPE_LABEL: 'Meeting Type',
    SCHEDULER_MEETING_TYPES_LABEL: 'Meeting Types',
    SCHEDULER_TEMPLATE_PLACEHOLDER: 'Sélectionner',
    SCHEDULER_DURATION_LABEL: 'Durée',
    SCHEDULER_TOTAL_DURATION_LABEL: 'Durée totale',
    SCHEDULER_DURATION_DIMENSION_MINUTES_FULL_LABEL: 'minutes',
    SCHEDULER_DURATION_DIMENSION_HOURS_FULL_LABEL: 'heures',
    SCHEDULER_DURATION_DIMENSION_MINUTES_SHORT_LABEL: 'min',
    SCHEDULER_DURATION_DIMENSION_HOURS_SHORT_LABEL: 'h',
    SCHEDULER_DURATION: 'durée',
    SCHEDULER_BUFFER: 'marge',
    SCHEDULER_BUFFER_TIME_NONE_LABEL: 'Aucun',
    SCHEDULER_BUFFER_TIME_MIN5_LABEL: '5 min',
    SCHEDULER_BUFFER_TIME_MIN10_LABEL: '10 min',
    SCHEDULER_BUFFER_TIME_MIN15_LABEL: '15 min',
    SCHEDULER_BUFFER_TIME_MIN20_LABEL: '20 min',
    SCHEDULER_BUFFER_TIME_MIN25_LABEL: '25 min',
    SCHEDULER_BUFFER_TIME_MIN30_LABEL: '30 min',
    SCHEDULER_BUFFER_TIME_MIN35_LABEL: '35 min',
    SCHEDULER_BUFFER_TIME_MIN40_LABEL: '40 min',
    SCHEDULER_BUFFER_TIME_MIN45_LABEL: '45 min',
    SCHEDULER_BUFFER_TIME_MIN50_LABEL: '50 min',
    SCHEDULER_BUFFER_TIME_MIN55_LABEL: '55 min',
    SCHEDULER_BUFFER_TIME_MIN60_LABEL: '60 min',
    SCHEDULER_BUFFER_LABEL: 'Marge',
    SCHEDULER_BUFFER_TOOLTIP: 'Bloquez le calendrier de l’hôte avant et/ou après cette réunion pendant cette durée. Les temps de marge servent généralement à la préparation, au débriefing ou au déplacement lors des réunions en personne.',
    SCHEDULER_BUFFER_BEFORE_LABEL: 'Avant',
    SCHEDULER_BUFFER_AFTER_LABEL: 'Après',
    SCHEDULER_LOCATION_LABEL: 'Lieu',
    SCHEDULER_LOCATION_VIDEO_CONFERENCE: 'Visioconférence',
    SCHEDULER_LOCATION_IN_PERSON: 'En personne',
    SCHEDULER_LOCATION_PHONE: 'Téléphone',
    SCHEDULER_LOCATION_PHONE_HOST_PHONE: 'Hôte',
    SCHEDULER_LOCATION_PHONE_INVITEE_PHONE: 'Invité',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PHONE: 'Personnalisé',
    SCHEDULER_LOCATION_INTEGRATION_ENABLED_LABEL: 'Inclure les détails de visioconférence',
    SCHEDULER_LOCATION_INTEGRATION_ZOOM_LABEL: 'Zoom',
    SCHEDULER_LOCATION_INTEGRATION_GOOGLE_MEET_LABEL: 'Google Meet',
    SCHEDULER_LOCATION_INTEGRATION_MICROSOFT_TEAMS_LABEL: 'Microsoft Teams',
    SCHEDULER_LOCATION_PHYSICAL_ADDRESS_PLACEHOLDER: 'Choisir une adresse',
    SCHEDULER_LOCATION_ROOM_PLACEHOLDER: 'Salle',
    SCHEDULER_LOCATION_RESOURCES_PLACEHOLDER: 'Ressources',
    SCHEDULER_LOCATION_CUSTOM_ADDRESS_PLACEHOLDER: 'Saisir une adresse personnalisée',
    SCHEDULER_LOCATION_PHONE_CUSTOM_PLACEHOLDER: 'Saisir le numéro de téléphone',
    SCHEDULER_LOCATION_IN_PERSON_LOCATION: "Lieux de l'organisation",
    SCHEDULER_LOCATION_IN_PERSON_CUSTOM_ADDRESS: 'Adresse personnalisée',
    SCHEDULER_LOCATION_IN_PERSON_INVITEE_LOCATION: "Lieu de l'invité",
    SCHEDULER_AVAILABILITY_LABEL: 'Disponibilité',
    SCHEDULER_AVAILABILITY_TOOLTIP: "Le mode ouvert offrira le plus de dates/heures disponibles à l'invité principal. Les options supplémentaires (personnalisé, fenêtre glissante, plage de dates) permettent de limiter les créneaux proposés.",
    SCHEDULER_AVAILABILITY_OPEN: 'Ouvert',
    SCHEDULER_AVAILABILITY_CUSTOM: 'Personnalisé',
    SCHEDULER_AVAILABILITY_ROLLING: 'Glissant',
    SCHEDULER_AVAILABILITY_RANGE: 'Plage',
    SCHEDULER_AVAILABILITY_OPEN_DESCRIPTION: "Cette réunion peut être planifiée à n'importe quelle date/heure disponible, à partir du moment où le participant clique sur le lien d’invitation.",
    SCHEDULER_AVAILABILITY_CUSTOM_DESCRIPTION: 'Dans le calendrier, vous pouvez dessiner votre disponibilité personnalisée pour cette invitation. Les participants ne verront que les horaires que vous avez définis comme disponibles.',
    SCHEDULER_AVAILABILITY_ROLLING_DESCRIPTION: "Des créneaux disponibles seront proposés aux participants pendant une période commençant lorsqu'ils cliquent sur le lien d’invitation.",
    SCHEDULER_AVAILABILITY_ROLLING_WINDOW_LABEL: 'Fenêtre (jours)',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_LABEL: 'Expiration',
    SCHEDULER_AVAILABILITY_ROLLING_EXPIRATION_PLACEHOLDER: 'Jamais',
    SCHEDULER_AVAILABILITY_RANGE_DESCRIPTION: 'Sélectionnez une plage de dates de disponibilité à proposer.',
    SCHEDULER_AVAILABILITY_RANGE_START_LABEL: 'Début',
    SCHEDULER_AVAILABILITY_RANGE_START_DATE_PLACEHOLDER: 'Date de début',
    SCHEDULER_AVAILABILITY_RANGE_START_TIME_PLACEHOLDER: 'Heure de début',
    SCHEDULER_AVAILABILITY_RANGE_END_LABEL: 'Fin',
    SCHEDULER_AVAILABILITY_RANGE_END_DATE_PLACEHOLDER: 'Date de fin',
    SCHEDULER_AVAILABILITY_RANGE_END_TIME_PLACEHOLDER: 'Heure de fin',
    SCHEDULER_LIMIT_LABEL: 'Limite',
    SCHEDULER_LIMIT_TOOLTIP: 'Limitez le nombre de rendez-vous pouvant être réservés avec cette invitation/ce lien. Une fois la limite atteinte, cette invitation/ce lien expirera automatiquement.',
    SCHEDULER_LIMIT_LIMIT1_LABEL: '1',
    SCHEDULER_LIMIT_LIMIT2_LABEL: '2',
    SCHEDULER_LIMIT_LIMIT3_LABEL: '3',
    SCHEDULER_LIMIT_LIMIT4_LABEL: '4',
    SCHEDULER_LIMIT_LIMIT5_LABEL: '5',
    SCHEDULER_LIMIT_LIMIT6_LABEL: '6',
    SCHEDULER_LIMIT_LIMIT7_LABEL: '7',
    SCHEDULER_LIMIT_LIMIT8_LABEL: '8',
    SCHEDULER_LIMIT_LIMIT9_LABEL: '9',
    SCHEDULER_LIMIT_LIMIT10_LABEL: '10',
    SCHEDULER_LIMIT_UNLIMITED_LABEL: 'Illimité',
    SCHEDULER_HOST_LABEL: 'Hôte',
    SCHEDULER_HOST_PLACEHOLDER: "Ajouter l'hôte",
    SCHEDULER_ADD_GUEST_LABEL: 'Ajouter des participants',
    SCHEDULER_ADD_GUEST_PLACEHOLDER: 'Rechercher par nom ou e-mail',
    SCHEDULER_MAIN_GUEST_LABEL: 'Invité',
    SCHEDULER_NOTE_LABEL: "Note pour l'invité et les participants",
    SCHEDULER_MAIN_GUEST_TOOLTIP: 'Si l’invité est défini, cliquez sur « Insérer les créneaux et fermer » pour ajouter des créneaux à l’e-mail. Sinon, cliquez sur « Copier le lien et fermer » pour l’envoyer à n’importe qui ; l’invité pourra s’identifier lors de la réservation.',
    SCHEDULER_MAIN_GUEST_PLACEHOLDER: 'Rechercher par nom ou e-mail',
    SCHEDULER_GUESTS_LABEL: 'Participants',
    SCHEDULER_DESCRIPTION_LABEL: "Note de l'hôte",
    SCHEDULER_INSERT_BUTTON_LABEL: 'Insérer les créneaux et fermer',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_LABEL: 'Réserver et fermer',
    SCHEDULER_BOOK_AND_NEW_BUTTON_LABEL: 'Réserver et nouveau',
    SCHEDULER_INSERT_BUTTON_TOOLTIP: 'Insérera des créneaux disponibles dans votre e-mail.',
    SCHEDULER_BOOK_AND_NEW_BUTTON_TOOLTIP: 'Réserve immédiatement et réinitialise pour une nouvelle réservation.',
    SCHEDULER_BOOK_AND_CLOSE_BUTTON_TOOLTIP: 'Réserve immédiatement et ferme Meeting Booker.',
    SCHEDULER_COPY_LINK_BUTTON_LABEL: 'Copier le lien et fermer',
    SCHEDULER_COPY_LINK_BUTTON_TOOLTIP: 'Copiera ce lien de réservation que vous pourrez coller dans un e-mail.',
    SCHEDULER_BUTTON_PREVIOUS_WEEK: 'Semaine précédente',
    SCHEDULER_BUTTON_NEXT_WEEK: 'Semaine suivante',
    SCHEDULER_BUTTON_THIS_WEEK: 'Cette semaine',
    SCHEDULER_BUTTON_TODAY: "aujourd'hui",
    SCHEDULER_ERROR: 'Erreur',
    INTERNAL_SERVER_ERROR: 'Erreur interne du serveur',
    INTERNAL_SERVER_ERROR_ALERT: "L'ouverture en BLANC sera insérée dans l'invitation.",
    SCHEDULER_CREATE_BOOKING_PAGE_ERROR: 'Échec de la requête CreateBookingPage. Veuillez réessayer plus tard',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_ERROR: 'Mettez votre offre à niveau, vous avez atteint la limite.',
    SCHEDULER_CREATE_BOOKING_PAGE_LIMIT_LINK: 'Découvrir les offres',
    SCHEDULER_MEMBERS_ERROR: 'Échec de la requête des membres. Veuillez réessayer plus tard',
    SCHEDULER_TEMPLATE_ERROR: 'Échec de la requête des modèles. Veuillez réessayer plus tard',
    GET_USER_LOGIN_ERROR_MESSAGE: "Aucun compte n'existe avec cet e-mail",
    GET_USER_AUTH_ERROR_MESSAGE: "Échec de la demande d'authentification",
    GET_USER_LOGOUT_ERROR_MESSAGE: 'Échec de la demande de déconnexion',
    DELETE_USER_SUCCESS_MESSAGE: "Échec de la demande d'authentification",
    DELETE_USER_ERROR_MESSAGE: "Échec de la demande de suppression d'utilisateur",
    CHOOSE_AN_ACCOUNT_ERROR_TOAST: 'Échec du choix du compte',
    GET_MAIN_DATA_ERROR_MESSAGE: "Échec de la demande d'authentification",
    ROLE_DEACTIVATED_ERROR_MESSAGE: 'Le rôle a été désactivé. Veuillez contacter votre administrateur Omnito.',
    USER_DEACTIVATED_ERROR_MESSAGE: "L'utilisateur a été désactivé. Veuillez contacter votre administrateur Omnito.",
    TRIAL_LIMIT_ERROR_MESSAGE: 'Vous avez dépassé la limite de 40 éléments pour la version d’essai',
    ACCOUNT_ALREADY_EXIST_ERROR_TOAST_MESSAGE: 'Un autre compte est déjà associé à cet e-mail',
    DELETE_ROLE_ASSIGNED_ERROR_MESSAGE: 'Impossible de supprimer. Des utilisateurs sont affectés à ce rôle.',
    INVALID_GOOGLE_MAP_API_KEY_ERROR_MESSAGE: 'Clé API Google invalide ou services requis non activés.',
    IMPORT_LOCATIONS_LIMIT_ERROR_MESSAGE: "Échec de l'importation : limite de 100 lieux dépassée. Veuillez scinder votre fichier.",
    PRICING_TIER_ACCESS_EXCEPTION_MESSAGE: "Veuillez mettre à niveau votre formule d'abonnement pour accéder à cette fonctionnalité.",
    RESEND_USER_INVITE_ERROR_MESSAGE: "Un enregistrement d'administrateur avec cet e-mail existe déjà pour cette organisation",
    ACTIVE_TAB_SIDEBAR_LICENSE_ERROR: 'Votre licence a expiré. Veuillez vérifier votre abonnement.',
    PLEASE_WAIT_AND_TRY_AGAIN: 'Veuillez patienter et réessayer',
    FAILED_TO_LOAD_SCHEDULER_DATA: 'Échec du chargement des données du planificateur…',
    MEETING_BOOKER_INSTALLED: 'Meeting Booker est installé.',
    TRY_AGAIN: 'Réessayer',
    SPOTS_WIDGET_CLICK_HERE: 'Cliquez ici',
    SPOTS_WIDGET_VIEW_MORE_OPTIONS: 'pour voir plus d’options',
    SPOTS_WIDGET_SELECT_TIME_SLOT: 'pour sélectionner un créneau disponible',
    SCHEDULER_COPY_LINK: 'Copier le lien',
    SCHEDULER_ADD_INVITEE: 'Ajouter un invité',
    SCHEDULER_ADD_ATTENDEE: 'Ajouter un participant',
    SEARCH_ATTENDEE_PLACEHOLDER: 'Rechercher ou saisir pour ajouter un participant',
    SEARCH_HOST_PLACEHOLDER: "Rechercher ou saisir pour sélectionner l'hôte",
    SHOW_WEEKENDS: 'Afficher les week-ends',
    INVITEE_AMD_ATTENDEES: 'Invité et participants',
    SCHEDULER_BOOKING_TOOLS: 'Outils de réservation',
    SCHEDULER_USER_SETTINGS: "Paramètres de l'utilisateur",
    SCHEDULER_ALL_PERSONAL_LINKS: 'Tous les liens personnels',
    SCHEDULER_TOOLS: 'Outils',
    SCHEDULER_TEMPLATES: 'Modèles',
    SCHEDULER_TOOLS_AVAILABILITY: 'Disponibilité',
    SCHEDULER_TOOLS_INTEGRATE: 'Intégrations',
    SCHEDULER_TOOLS_BOOKING_PAGES: 'Types de réunion',
    SCHEDULER_TOOLS_MY_BOOKING_PAGES: 'Mes types de réunion',
    SCHEDULER_TOOLS_SHARED_BOOKING_PAGES: 'Types de réunion partagés',
    SCHEDULER_HEADER_TAB_1: 'Proposer des horaires de réservation',
    SCHEDULER_HEADER_TAB_2: 'Réunion instantanée',
    SCHEDULER_DEFAULT_INVITEE_NAME_LABEL: 'Nom',
    SCHEDULER_DEFAULT_INVITEE_EMAIL_LABEL: 'E-mail',
    SCHEDULER_GUIDE_TITLE: 'Bienvenue dans Meeting Booker',
    SCHEDULER_ONBOARDING: 'Parcours d’intégration',
    SCHEDULER_SKIP: 'Passer',
    SCHEDULER_GUIDE_DESCRIPTION: 'Planifiez des réunions sans effort — directement depuis votre e-mail. Choisissez votre disponibilité, insérez des créneaux dans votre message et laissez les autres choisir ce qui leur convient le mieux.',
    SCHEDULER_GUIDE_HOW_IT_WORKS: 'Comment ça marche',
    SCHEDULER_GUIDE_STEP_1_TITLE: 'Étape 1 : Connectez-vous ou créez votre compte',
    SCHEDULER_GUIDE_STEP_1_DESCRIPTION: 'Utilisez votre e-mail pour vous connecter ou créez rapidement un nouveau compte pour commencer avec Meeting Booker.',
    SCHEDULER_GUIDE_STEP_2_TITLE: 'Étape 2 : Rédigez un nouvel e-mail',
    SCHEDULER_GUIDE_STEP_2_DESCRIPTION: 'Rédigez un e-mail et cliquez sur l’icône Meeting Booker dans la barre d’outils.',
    SCHEDULER_GUIDE_STEP_3_TITLE: 'Étape 3 : Configurez votre réunion',
    SCHEDULER_GUIDE_STEP_3_DESCRIPTION: 'Choisissez la durée, le type de réunion, les créneaux, les invités et ajoutez une note — le tout synchronisé avec votre calendrier.',
    SCHEDULER_GUIDE_STEP_4_TITLE: 'Étape 4 : Insérez des créneaux dans votre e-mail',
    SCHEDULER_GUIDE_STEP_4_DESCRIPTION: 'Cliquez sur « Insérer les créneaux et fermer » — nous ajouterons votre disponibilité directement dans le message. Envoyez-le et laissez-les choisir !',
    SCHEDULER_GUIDE_GET_STARTED_BUTTON: 'Commencer',
    SCHEDULER_BOOKED_SUCCESS_MESSAGE: "C'est réservé !",
    SCHEDULER_BOOKED_SUCCESS_MESSAGE_CHECK_INBOX: 'Vérifiez votre boîte de réception pour un e-mail contenant tous les détails.',
    SCHEDULER_BOOKED_ERROR_MESSAGE: 'Créneau horaire requis',
    SCHEDULER_BOOKED_ERROR_MESSAGE_PICK_TIME_SLOT: 'Veuillez choisir un créneau dans le calendrier pour réserver votre réunion.',
    CHARACTER_LIMIT_REACHED: 'Limite atteinte',
    SCHEDULER_TIME_SLOT_TO_SHORT_TITLE: 'Veuillez choisir un créneau plus long dans le calendrier.',
    SCHEDULER_TIME_SLOT_TO_SHORT_DESCRIPTION: `Ce créneau est trop court. Votre réunion requiert ${ReplacesEnum_1.ReplacesDetailEnum.DURATION}.`,
    SCHEDULER_TIMEZONE_NOT_SELECTED_TITLE: 'Fuseau horaire non sélectionné',
    SCHEDULER_TIMEZONE_NOT_SELECTED_DESCRIPTION: 'Veuillez sélectionner un fuseau horaire dans le menu déroulant du calendrier avant d\'insérer des créneaux.',
    NO_ACTIVE_WORKSPACES_TITLE: 'Aucun espace de travail actif',
    NO_ACTIVE_WORKSPACES: 'Il n’y a actuellement aucun espace de travail actif. Cela devrait être résolu bientôt — revenez plus tard ou contactez votre administrateur.',
    WEEKDAYS_ONLY: 'Jours ouvrés uniquement',
    INCLUDE_WEEKENDS: 'Inclure les week-ends',
    SUCCESS: 'Succès',
    ERROR: 'Erreur',
    INFO: 'Info',
    WARNING: 'Avertissement',
    CALENDAR_DISPLAY: 'Afficher le calendrier',
    MY_BOOKING_PAGES: 'Mes types de réunion',
    SHARED_BOOKING_PAGES: 'Types de réunion partagés',
    SCHEDULER_MY_MEETINGS_LABEL: 'My Meetings',
    SCHEDULER_SHARED_MEETINGS_LABEL: 'Shared with me',
    SCHEDULER_TEAM_LABEL: 'Team',
    SCHEDULER_ROUND_ROBIN_LABEL: 'Round-Robin',
    SCHEDULER_POOL_LABEL: 'Pool',
    SCHEDULER_USER_DOES_NOT_HAVE_NECESSARY_PERMISSIONS: `L'utilisateur n'a pas les permissions nécessaires`,
    CORS_CONFIGURATION_REQUIRED_TITLE: 'CORS-Configuration requise',
    CORS_CONFIGURATION_REQUIRED_TEXT: 'L\'accès aux informations de l\'utilisateur est bloqué par les paramètres CORS de Salesforce. Contactez votre administrateur Salesforce pour résoudre ce problème.',
    GMAIL_CONTACTS_TOOLTIP: 'Contacts Gmail',
    OUTLOOK_CONTACTS_TOOLTIP: 'Contacts Outlook',
    SALESFORCE_TOOLTIP: 'Salesforce',
    SALESFORCE_LEAD_TOOLTIP: 'Lead',
    SALESFORCE_CONTACT_TOOLTIP: 'Contact',
    SALESFORCE_PERSON_ACCOUNT_TOOLTIP: 'Person Account',
    SALESFORCE_TEAM_TOOLTIP: 'Team',
    SALESFORCE_RESOURCE_TOOLTIP: 'Resource',
    SALESFORCE_BUCKET_TOOLTIP: 'Bucket',
    SALESFORCE_USER_TOOLTIP: 'User',
    HUBSPOT_TOOLTIP: 'HubSpot',
    SUMO_FOR_SALESFORCE_CEP_TOOLTIP: 'Omnito pour Salesforce (CEP)',
    SERVICE_NOW_TOOLTIP: 'ServiceNow',
    SCHEDULER_MINIMUM_NOTICE_PERIOD_LABEL: 'Période de notification minimale',
    SCHEDULER_DURATION_WARNING: 'Attention : La durée totale est inférieure à celle des services sélectionnés.',
    SCHEDULER_HOST_LIMIT_WARNING: "L'hôte actuellement sélectionné a dépassé sa limite personnelle de rendez-vous pour le type de rendez-vous sélectionné.",
    SCHEDULER_BUSY: 'Occupé',
    // Login
    LOGIN_OR: 'ou',
    LOGIN_EMAIL_PLACEHOLDER: 'Entrez votre adresse e-mail',
    LOGIN_CONTINUE: 'Continuer',
    LOGIN_BACK: 'Retour',
    LOGIN_PASSWORD_LABEL: 'Mot de passe',
    LOGIN_BUTTON: 'Se connecter',
    LOGIN_FORGOT_PASSWORD: 'Mot de passe oublié ?',
    LOGIN_SEND_RECOVERY_EMAIL: 'Envoyer un e-mail de récupération',
    FORGOT_PASSWORD_SUCCESS_MESSAGE: 'E-mail de récupération envoyé ! Vérifiez votre boîte de réception pour un lien de réinitialisation de mot de passe.',
    LOGIN_INVALID_EMAIL: 'Veuillez entrer une adresse e-mail valide',
    LOGIN_INVALID_PASSWORD: 'Veuillez entrer votre mot de passe',
    LOGIN_NO_ACCOUNT: 'Aucun compte trouvé avec cet e-mail.',
    // MFA (TOTP)
    MFA_TITLE: 'Authentification à deux facteurs',
    MFA_SUBTITLE: "Entrez le code à 6 chiffres de votre application d'authentification.",
    MFA_VERIFY: 'Vérifier',
    MFA_SAVE_THIS_DEVICE: 'Enregistrer cet appareil',
    MFA_INCORRECT_CODE: 'Code incorrect. Veuillez réessayer.',
});
